import { render, staticRenderFns } from "./FormTaskTemplate.vue?vue&type=template&id=24f81a3e"
import script from "./FormTaskTemplate.vue?vue&type=script&lang=js"
export * from "./FormTaskTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports